import { Navigate, useRoutes } from 'react-router-dom';

import AppRoutes from './app-routes';
import AuthRoutes from './auth-routes';

export default function ThemeRoutes() {
  return useRoutes([
    ...AppRoutes,
    ...AuthRoutes,
    { path: '*', element: <Navigate to='/' replace /> },
  ]);
}
